import { apiClient } from './client';
import type {
  ExpeditorAgreementCreateInput,
  ExpeditorAgreementDto,
} from '@expeditor/shared';

/** Договоры ТЭО: клиент видит свои действующие, менеджер заводит для клиента. */
export const agreementsApi = {
  /** Клиент: свои действующие договоры (для выбора в поручении). */
  async listActive(): Promise<ExpeditorAgreementDto[]> {
    const { data } = await apiClient.get<ExpeditorAgreementDto[]>('/agreements/active');
    return data;
  },
  /** Клиент: все свои договоры (включая архивные) — для профиля. */
  async listMine(): Promise<ExpeditorAgreementDto[]> {
    const { data } = await apiClient.get<ExpeditorAgreementDto[]>('/agreements');
    return data;
  },
  /** Менеджер: все договоры клиента. */
  async listForClient(clientId: string): Promise<ExpeditorAgreementDto[]> {
    const { data } = await apiClient.get<ExpeditorAgreementDto[]>(
      `/manager/clients/${clientId}/agreements`,
    );
    return data;
  },
  /** Менеджер: завести договор для клиента. */
  async createForClient(
    clientId: string,
    dto: ExpeditorAgreementCreateInput,
  ): Promise<ExpeditorAgreementDto> {
    const { data } = await apiClient.post<ExpeditorAgreementDto>(
      `/manager/clients/${clientId}/agreements`,
      dto,
    );
    return data;
  },
  /** Менеджер: архивировать договор. */
  async archive(clientId: string, id: string): Promise<ExpeditorAgreementDto> {
    const { data } = await apiClient.post<ExpeditorAgreementDto>(
      `/manager/clients/${clientId}/agreements/${id}/archive`,
    );
    return data;
  },
};
